/* eslint-disable no-useless-escape */
import React, { useRef, useState, useEffect, useMemo, useCallback } from 'react';
import useThemeMode from '@hooks/Applications/useThemeMode';
import AceEditor from 'react-ace';
import ace from 'ace-builds';
ace.config.set('basePath', import.meta.env.BASE_URL + 'node_modules/ace-builds/src-noconflict/');
import 'ace-builds/src-noconflict/mode-csharp'; // وضع لغة JavaScript
import 'ace-builds/src-noconflict/ext-language_tools'; // أدوات اللغة
import 'ace-builds/src-noconflict/theme-terminal';
import {type  FormikProps } from 'formik';
// import useGetStaticElement from '@hooks/Payrolls/useGetStaticElement';

type Suggestion = {
  id: string;
  name: string;
  value: string;
  description: string;
};

interface Props {
  formik: FormikProps<any>;
  StaticElementCode?: object;
  elementCodes?: object;
  PayrollConditionCodes?: object;
}

const CodeInput: React.FC<Props> = ({
  formik,
  elementCodes,
  StaticElementCode,
  PayrollConditionCodes
}) => {
  const mode = useThemeMode();
  // console.log(PayrollConditionCodes);

  const fixedComment = '// اكتــب صيغة الراتب هنا\n'; // السطر الثابت
  // const [code, setCode] = useState('');
  const [hoveredWord, setHoveredWord] = useState<string | null>(null);
  const aceEditorRef = useRef<any>(null); // إنشاء Ref للمحرر
  const [editorRef, setEditorRef] = useState<any>(null);
  const [markers, setMarkers] = useState<any[]>([]);

  // الاقتراحات المخصصة
  const [Suggestions, setSuggestions] = useState<Suggestion[]>([
    ...(Array.isArray(elementCodes) ? elementCodes : []),
    ...(Array.isArray(StaticElementCode) ? StaticElementCode : []),
    ...(Array.isArray(PayrollConditionCodes) ? PayrollConditionCodes : [])
  ]);

  //#region    //  Markers
  // const updateMarkers = (editor: any) => {
  //   // إزالة العلامات القديمة
  //   markers.forEach(marker => editor.session.removeMarker(marker));

  //   const newMarkers: any[] = [];
  //   const session = editor.session;
  //   const regex = /(?<!\w)\$\w+\$(?!\w)/g;

  //   // استخراج جميع القيم الموجودة في customSuggestions
  //   const allowedWords = new Set(Suggestions.map(item => item.value));

  //   for (let row = 0; row < session.getLength(); row++) {
  //     const line = session.getLine(row);
  //     let match: any;

  //     while ((match = regex.exec(line)) !== null) {
  //       const word = match[0]; // الكلمة المطابقة

  //       if (allowedWords.has(word)) {
  //         // التحقق من وجودها في customSuggestions
  //         const startCol = match.index;
  //         const endCol = match.index + match[0].length;

  //         // إنشاء العلامة بنوع 'screen' وليس 'text'
  //         const range = new (window as any).ace.Range(row, startCol, row, endCol);
  //         const markerId = session.addMarker(
  //           range,
  //           'ace_at_word',
  //           'screen', // النوع المهم هنا
  //           false
  //         );

  //         newMarkers.push(markerId);
  //       }
  //     }
  //   }

  //   setMarkers(newMarkers);
  // };
  const updateMarkers = (editor: any) => {
    // إزالة العلامات القديمة
    markers.forEach(marker => editor.session.removeMarker(marker));
  
    const newMarkers: any[] = [];
    const session = editor.session;
  
    // الأنماط المدعومة مع الكلاسات الخاصة بها
    const regexClassMap = [
      { regex: /(?<!\w)\$\w+\$(?!\w)/g, className: 'ace_at_word' },
      { regex: /(?<!\w)\#\w+\#(?!\w)/g, className: 'ace_hash_word' }
    ];
  
    // استخراج جميع القيم الموجودة في customSuggestions
    const allowedWords = new Set(Suggestions.map(item => item.value));
  
    for (let row = 0; row < session.getLength(); row++) {
      const line = session.getLine(row);
  
      for (const { regex, className } of regexClassMap) {
        let match: any;
  
        while ((match = regex.exec(line)) !== null) {
          const word = match[0]; // الكلمة المطابقة
  
          if (allowedWords.has(word)) {
            // التحقق من وجودها في customSuggestions
            const startCol = match.index;
            const endCol = match.index + word.length;
  
            // إنشاء العلامة بنوع 'screen' وليس 'text'
            const range = new (window as any).ace.Range(row, startCol, row, endCol);
            const markerId = session.addMarker(range, className, 'screen', false);
  
            newMarkers.push(markerId);
          }
        }
      }
    }
  
    setMarkers(newMarkers);
  };
  
  //#endregion

  const handleEditorLoad = (editor: any) => {
    setEditorRef(editor);
    updateMarkers(editor);

    //#region  // completers
    const langTools = (window as any).ace.require('ace/ext/language_tools');

    // تجهيز المكملات بناءً على `Suggestions`
    const completers = Suggestions.map(item => ({
      caption: item.name,
      value: item.value,
      meta: `${item.description}`
    }));

    const customCompleter = {
      getCompletions: (_editor: any, _session: any, _pos: any, _prefix: any, callback: any) => {
        callback(null, completers);
      }
    };

    // إزالة جميع المكملات الافتراضية وإضافة المكمل الجديد
    langTools.setCompleters([customCompleter]);
    //#endregion

    //#region  // إعداد أوامر الحذف المخصصة

    // const setupDeleteCommand = (isBackspace: boolean) => {
    //   editor.commands.addCommand({
    //     name: isBackspace ? 'smartBackspace' : 'smartDelete',
    //     bindKey: {
    //       win: isBackspace ? 'Backspace' : 'Delete',
    //       mac: isBackspace ? 'Backspace' : 'Delete'
    //     },
    //     exec: (editor: any) => {
    //       const cursor = editor.getCursorPosition();
    //       const session = editor.session;
    //       const line = session.getLine(cursor.row);
    //       // const regex = /@\w+@/g;
    //       const regex = /\$\w+\$/g;
          

    //       // استخراج جميع القيم الموجودة في customSuggestions
    //       const allowedWords = new Set(Suggestions.map(item => item.value));

    //       let match;
    //       while ((match = regex.exec(line)) !== null) {
    //         const word = match[0]; // الكلمة المطابقة
    //         const startCol = match.index;
    //         const endCol = match.index + match[0].length;

    //         if (allowedWords.has(word)) {
    //           // الحذف فقط إذا كانت الكلمة ضمن القائمة المسموح بها
    //           if (
    //             (isBackspace && cursor.column === endCol) ||
    //             (!isBackspace && cursor.column === startCol)
    //           ) {
    //             session.remove({
    //               start: { row: cursor.row, column: startCol },
    //               end: { row: cursor.row, column: endCol }
    //             });
    //             return;
    //           }
    //         }
    //       }

    //       // إذا لم تكن الكلمة موجودة أو لم يكن هناك تطابق، نفذ السلوك الافتراضي
    //       editor.execCommand(isBackspace ? 'backspace' : 'del');
    //     }
    //   });
    // };

    const setupDeleteCommand = (isBackspace: boolean) => {
      editor.commands.addCommand({
        name: isBackspace ? 'smartBackspace' : 'smartDelete',
        bindKey: {
          win: isBackspace ? 'Backspace' : 'Delete',
          mac: isBackspace ? 'Backspace' : 'Delete'
        },
        exec: (editor: any) => {
          const cursor = editor.getCursorPosition();
          const session = editor.session;
          const line = session.getLine(cursor.row);
    
          // الأنماط المدعومة: $...$ و #...#
          const regexList = [/\$\w+\$/g, /\#\w+\#/g];
    
          // استخراج جميع القيم الموجودة في customSuggestions
          const allowedWords = new Set(Suggestions.map(item => item.value));
    
          for (const regex of regexList) {
            let match;
            while ((match = regex.exec(line)) !== null) {
              const word = match[0]; // الكلمة المطابقة
              const startCol = match.index;
              const endCol = match.index + word.length;
    
              if (allowedWords.has(word)) {
                // الحذف فقط إذا كانت الكلمة ضمن القائمة المسموح بها
                if (
                  (isBackspace && cursor.column === endCol) ||
                  (!isBackspace && cursor.column === startCol)
                ) {
                  session.remove({
                    start: { row: cursor.row, column: startCol },
                    end: { row: cursor.row, column: endCol }
                  });
                  return;
                }
              }
            }
          }
    
          // إذا لم تكن الكلمة موجودة أو لم يكن هناك تطابق، نفذ السلوك الافتراضي
          editor.execCommand(isBackspace ? 'backspace' : 'del');
        }
      });
    };
    
    setupDeleteCommand(true); // Backspace
    setupDeleteCommand(false); // Delete

    //#endregion

    //#region    // إضافة حدث تمرير الماوس
    editor.on('mousemove', (e: any) => {
      const { x, y } = e; // إحداثيات الماوس
      const position = editor.renderer.screenToTextCoordinates(x, y); // تحويلها إلى إحداثيات النص
      const session = editor.session;
      const line = session.getLine(position.row); // الحصول على السطر الحالي
      const regex = /\$\w+\$/g; // البحث عن الكلمات المطابقة

      let match;
      let foundWord = null;

      while ((match = regex.exec(line)) !== null) {
        const startCol = match.index;
        const endCol = match.index + match[0].length;

        if (position.column >= startCol && position.column <= endCol) {
          foundWord = match[0]; // حفظ الكلمة المطابقة
          break;
        }
      }

      setHoveredWord(foundWord); // تحديث الحالة عند العثور على كلمة متطابقة
    });

    //#endregion
  };

  return (
    <>
      <div
        className='w-100 border border-1 border-theme'
        style={{ height: '220px' }}
        onMouseLeave={() => setHoveredWord(null)}
      >
        <AceEditor
          placeholder={fixedComment}
          mode='csharp'
          theme={mode === 'dark' ? 'twilight' : 'textmate'}
          name='code-editor'
          fontSize={18}
          showPrintMargin={true}
          showGutter={true}
          highlightActiveLine={true}
          value={formik.values.formula}
          onChange={newValue => {
            formik.setFieldValue('formula', newValue);
            if (editorRef) {
              updateMarkers(editorRef);
            }
          }}
          onLoad={handleEditorLoad}
          ref={aceEditorRef} // ربط الـ ref بالمحرر
          setOptions={{
            enableBasicAutocompletion: true,
            enableLiveAutocompletion: true,
            enableSnippets: true,
            enableMobileMenu: true,
            showLineNumbers: true,
            tabSize: 2
          }}
          style={{ width: '100%', height: '100%', direction: 'ltr' }}
        />
      </div>

      {/* <div className='mt- p-2 bg-light '> */}
      <div className='mt- p-2 bg-theme bg-opacity-15 '>
        <div className='d-flex justify-content-between align-items-center mb-1 p-1 '>
          <div className='col-auto'>
            <p className='text-muted font-italic mb-0 fw-bold'>
              {Suggestions.find(f => f.value === hoveredWord)?.name}
            </p>
          </div>
          <div className='col-auto'>
            <p className='text-muted font-italic mb-0 '>
              اكتب <code className='bg-light p-1'>{'ctrl+space'}</code> لرؤية الاقتراحات
            </p>
          </div>
        </div>
      </div>

      {/* <style>
        {`
              .ace_at_word {
                position: absolute;
                // background-color:  rgba(var(--bs-theme-rgb), 0.2) ;
                  background-color: rgba(255, 215, 0, 0.3);
                // border: 1px var(--bs-theme) solid;
                border-radius: 4px;
                z-index: 3;
                margin: 0;
                padding: 0;
                pointer-events: none;
                color: black;
              }
              .ace_hash_word {
                position: absolute;
                // background-color:  rgba(var(--bs-theme-rgb), 0.2) ;
                background-color: rgba(0, 191, 255, 0.3);
                // border: 1px var(--bs-theme) solid;
                border-radius: 4px;
                z-index: 3;
                margin: 0;
                padding: 0;
                pointer-events: none;
                color: black;
              }

              .ace_editor.ace_autocomplete {
                  width: 400px;
                  font-size: 15px;
                  border: 1px var(--bs-theme) solid;
              }

              .ace_completion-meta {
                font-size: 12px;
              }

              .ace-github .ace_gutter {
                background : rgba(var(--bs-theme-rgb), 0.3) ;
                color: #5e5050;
              }
              .ace-tm .ace_gutter  {
                background : rgba(var(--bs-theme-rgb), 0.3  ) ;
                color: #5e5050;
              }

              .ace-github.ace_focus .ace_marker-layer .ace_active-line {
                background : rgba(var(--bs-theme-rgb), 0.2 ) ;
              }

              // .ace-tm.ace_focus .ace_marker-layer .ace_active-line {
              //   background : rgba(var(--bs-theme-rgb), 0.2 ) ;
              // }

              .ace_editor.ace_autocomplete .ace_marker-layer .ace_active-line {
                  background-color:rgba(var(--bs-theme-rgb), 0.2 ) ;
                }
                .ace-tm .ace_keyword.ace_operator {
                  color: rgb(0, 0, 0);
                 }

                 .ace-twilight .ace_keyword, .ace-twilight .ace_meta {
                     color: #dedede;
                 }

          `}
      </style> */}
    </>
  );
};

export default CodeInput;

{
  /* <div className='row'>
{Suggestions.map((item, index) => (
  <div key={item.id} className='col-md-4 mb-2'>
    <div
      className={`p-2 bg-inverse bg-opacity-20 rounded border-start  border-theme border-5 h-100 ${
        hoveredWord === item.value ? 'border-end' : ''
      }`}
    >
      <strong className=''>{item.name}:</strong>{' '}
      <code className='bg-inverse bg-opacity-15 p-1 rounded text-body '>
        {item.value}
      </code>
    </div>
  </div>
))}
</div> */
}
